export interface PM_Program_Interface {
  id:number,
  title:String,
  duration_id: number,
  detail: Array<number>,

  persianDate: string,
  username:string,
  del: boolean,

}

export function Empty_PM_Program_Interface():PM_Program_Interface{
  return{
    id:0,
    title:'',
    duration_id: 0,
    detail:[],

    persianDate: '',
    username:'',
    del: false,
  }
}
